/**
 * Public marketing opt-out: `/unsubscribe/:userID` writes excludeMarketing without sign-in.
 * Allowed by firestore.rules when request.auth.uid == null and only that field changes.
 */
import {
  Button,
  Center,
  Heading,
  SlideFade,
  VStack,
  Image,
  useColorModeValue,
  HStack,
  Text,
  useToast,
} from '@chakra-ui/react';
import { useContext, useState } from 'react';
import { Navigate, useNavigate, useParams } from 'react-router';
import { excludeUserFromMarketing } from '@/models/user';
import bannerLight from '../assets/logos/bannerLight.svg';
import bannerDark from '../assets/logos/bannerDark.svg';
import { VIEWPORT_MIN_H } from '@/constants/mobileLayout';
import { FirebaseContext } from '../session/FirebaseContext';
import { errorToastOptions, successToastOptions } from '../helpers';

export default function UnsubscribePage() {
  const ctx = useContext(FirebaseContext);
  const navigate = useNavigate();
  const toast = useToast();
  const heroSrc = useColorModeValue(bannerLight, bannerDark);
  const [isBusy, setIsBusy] = useState(false);
  const { userID } = useParams();

  async function submit() {
    if (userID) {
      setIsBusy(true);
      await excludeUserFromMarketing(ctx.db, userID)
        .then((_) => {
          setIsBusy(false);
          navigate('../../');
          toast(successToastOptions('Success!', 'You have now been unsubscribed from marketing emails.'));
        })
        .catch((err) => {
          setIsBusy(false);
          // console.error(err)
          toast(errorToastOptions('Something went wrong', 'Try again later or contact hello@tenteams.co.uk'));
        });
    } else {
      toast(errorToastOptions('Something went wrong', 'Try again later or contact hello@tenteams.co.uk'));
    }
  }

  if (userID) {
    return (
      <Center w='full' minH={VIEWPORT_MIN_H}>
        <VStack spacing={4} padding={8}>
          <Image src={heroSrc} height={16} />
          <SlideFade in>
            <VStack>
              <Heading pt={8} fontSize={28}>
                Unsubscribing from 10 Teams
              </Heading>
              <Text fontSize={22}>Are you sure you wish to unsubscribe from marketing emails from 10 Teams?</Text>
              <HStack pt={4}>
                <Button colorScheme={'red'} isLoading={isBusy} onClick={submit}>
                  Confirm
                </Button>
              </HStack>
            </VStack>
          </SlideFade>
        </VStack>
      </Center>
    );
  } else return <Navigate replace to='../' />;
}
